<template>
    <div class="col-md-6">
        <label class="attribute-label">Tax Rate</label>

        <div class="input-group width-100">
            <select  :name="name" :id="id" v-model="selected"  class="form-control price-new-inputs" @change="handleSelectionChange">
                <option v-if="options.length > 0" value="isNew" label="+ Add new tax rate">+ Add new tax rate</option>
                <option v-for="option of options" :value="option">
                    {{ option.tax_rate_name }} ({{ option.tax_rate_value }}%)
                </option>
            </select>
            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> % </b>
            </span>
            <div v-if="selected && selected.hasOwnProperty('tax_rate_id')" class="display-none">
                <input type="hidden" :name="name" :id="`${id}`" :value="selected.tax_rate_id">
                <input type="hidden" :name="valueName" :id="`${valueId}`" :value="selected.tax_rate_value">
            </div>
        </div>
        <tax-rate-popup  :id="modalId"></tax-rate-popup>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getTaxRateOptions} from "@/modules/Services/api/billing"
import TaxRatePopup from "@/modules/Services/components/billing/types/TaxRatePopup";

export default {
    name: "TaxRateField",
    components: {TaxRatePopup},
    props: {
        service: {
            type: Object,
            required: true
        },
        value: {}
    },
    data() {
        return {
            options: [],
            selected: null,
            addNewValue: { isNew: true }  // A unique value to identify the "+ Add new tax rate" option
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.service.clone)) {
                return `service_tax_id_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_tax_id_${this.service.service_id}`;
        },
        name() {
            if (parseInt(this.service.clone)) {
                return `service_tax_id_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_tax_id_${this.service.service_id}`;
        },
        modalId() {
            if (parseInt(this.service.clone)) {
                return `add-tax-rate-popup_${this.service.service_id}_${this.service.clone}`;
            }
            return `add-tax-rate-popup_${this.service.service_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        valueName() {
            if (parseInt(this.service.clone)) {
                return `service_tax_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_tax_${this.service.service_id}`;
        } ,
        valueId() {
            if (parseInt(this.service.clone)) {
                return `service_tax_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_tax_${this.service.service_id}`;
        }
    },
    methods: {
        loadOptions() {
            if(this.service?.taxRatesOptions?.length ){
                this.options = this.service.taxRatesOptions;
                if ( this.service.tax_rate.tax_rate_id){
                    this.selected = this.options.find(option => option.tax_rate_id == this.service.tax_rate.tax_rate_id)
                }
            }else{
                getTaxRateOptions(this.service.service_id)
                    .then(response => {
                        this.options = response.data || []
                        if ( this.service.tax_rate.tax_rate_id){
                            this.selected = this.options.find(option => option.tax_rate_id == this.service.tax_rate.tax_rate_id)
                        }
                    })
            }

        },
        listenToNewTaxRateOptionAdded(){
            EventBus.$on('newTaxRateOptionAdded', newOption => {

                this.options.push(newOption)
                this.selected = newOption
            })
        },
        handleSelectionChange() {
            this.$emit('input', this.selected)
            if (this.selected && this.selected == 'isNew') {
                let id = this.modalId;

                $("#" + id).modal("show")
            }
        },
    },
    created() {
        this.loadOptions()
    },
    mounted() {
        this.listenToNewTaxRateOptionAdded();
    },
    watch: {
        selected: {
            handler: function selectedListener(value) {
                this.$emit('input', value)
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>